import $ from 'jquery';

var directionsTimeout

export default class DirectionBox {
  constructor() {
    let that = this;

    /**
    * @name direction-box-show
    * @function
    * @param {config}
    * @description: Event listener for show direction box
    */
    $(document).bind('direction-box-show', function (e, config) {
      let timeout = config.timeout,
        directionData = config.data,
        className = config.className;

      $('.right-box-content').append(`<div class='directions ${className}'></div>`)

      directionsTimeout = setTimeout(function () {
        $('.directions').html(directionData)
        $('.directions').css('opacity', '1');
      }, timeout)
    }).bind(that);

    /**
    * @name direction-box-hide
    * @function
    * @param {config}
    * @description: Event listener for hide direction box
    */
    $(document).bind('direction-box-hide', function (e, config) {
      clearTimeout(directionsTimeout);
      $('.directions').remove();
    }).bind(that);
  }

}


// WEBPACK FOOTER //
// ./src/components/directionBox.js